import { render, staticRenderFns } from "./AddStockValue.vue?vue&type=template&id=7764ce74&"
import script from "./AddStockValue.vue?vue&type=script&lang=js&"
export * from "./AddStockValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports